/**
 * Styled Components
 */
import styled from 'styled-components'
import { WHITE, GRAY_LIGHT, BLUE } from '../../theme/colors'

export const Container = styled.div`
  background-color: ${WHITE};
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 109px);
  padding: 38px 12px;
  padding-bottom: 108px;
  @media (max-width: 698px) {
    padding: 38px 22px;
  }
`
export const Header = styled.div`
  background-color: ${WHITE};
  height: 70px;
  width: 100%;

  @media (max-width: 1099px) {
    display: none;
  }
`
export const ContentHeader = styled.div`
  align-items: center;
  display: flex;
  margin: auto;
  max-width: 1440px;
  padding: 18px 36px;
`
export const LogoIcon = styled.img``
export const Divider = styled.div`
  background-color: ${GRAY_LIGHT};
  height: 1px;
  width: 100%;
`
export const FormContainer = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: Avenir;
  margin-top: 28px;
  margin-bottom: 18px;
  max-width: 388px;
  text-align: center;
`

export const RevertDiv = styled.div`
  text-align: center;
  a {
    color: ${BLUE};
    text-decoration: underline;
  }
`

export const UpdatedImage = styled.img`
  max-width: 146px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Unsubscribe/styledComponents.tsx